import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { Utils } from '@src/utils/util';
import { ImpactAnalysisScopesComponent} from './impact-analysis-scopes'
import {HttpClientModule} from '@angular/common/http';
import { DbmAdditionalOptionsModule } from '@app/shared/components/dbm-components/dbm-additional-options/dbm-additional-options.module';
import {ImpactAnalysiSscope} from './impact-analysis-scope/impact-analysis-scope'

@NgModule({
    imports: [SharedModule, HttpClientModule , DbmAdditionalOptionsModule ],
    declarations: [ImpactAnalysisScopesComponent,ImpactAnalysiSscope],
    entryComponents: [ImpactAnalysisScopesComponent],
    exports: [ImpactAnalysisScopesComponent],
    providers: [ Utils]
})

export class ImpactAnalysisScopesModule{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis-scopes-ang7/impact-analysis-scopes.module.ts